<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-09-17 11:28:38
 * @name: 售后审批流
 * @Description: 售后审批流
 * @FilePath: \preSaleNafterSaleBackstage\src\views\approvalManage\afterSalesApprovalManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    
  </div>
</template>
<script>

export default {
  name: "afterSalesApprovalManage",
  components: {
    
  },
  data() {
    return {
     
    };
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>

</style>